/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectManagementWizard/rejectManagementWizardModal"/>
import * as React from "react";
import { RejectManagementWizard } from "./rejectManagementWizard";
import { mapFromNorthstarToApa } from "Core/Medius.Core.Web/Scripts/lib/northstarLocalization";
import { getCultureCode } from "Core/Medius.Core.Web/Scripts/Medius/lib/utils/user";
import { LocalizationContext } from "@medius/ui-controls";
import { RejectManagementWizardType } from "./interfaces";

export interface RejectManagementWizardModalProps {
    wizardType: RejectManagementWizardType;
    documentId: number;
    hierarchyId: string;
    show: boolean;
    onClose: () => void;
    action: () => void; 
}

export const RejectManagementWizardModal: React.FC<RejectManagementWizardModalProps> = ({ show, ...otherProps }) => {

    if (!show) return null;
    return (
        <LocalizationContext.Provider value={{
                translate: (key: string, defaultValue?: string) => mapFromNorthstarToApa(key, defaultValue),
                getLocale: () => getCultureCode()
            }}>
                <RejectManagementWizard {...otherProps} />
        </LocalizationContext.Provider>
    );
};